import { AschehougOidcClient } from "@aschehoug/aschehoug-oidc-client"
import type { RequestScopes } from "@aschehoug/aschehoug-oidc-client"

export function useOidcClient() {
  const origin = useCurrentOrigin()

  const { id } = useRuntimeConfig().public

  return new AschehougOidcClient({
    authority: id.authority,
    client_id: id.clientId,
    scope: "openid profile email" as RequestScopes.openIdProfile,
    redirect_uri: origin,
    post_logout_redirect_uri: origin,
    redirect_feide_uri: "",
    response_type: "code",
    metadata: {
      authorization_endpoint: id.authEndpoint,
    },
    base_uri_am: id.baseUrl,
  })
}
